module.exports = __webpack_public_path__ + "img/导购促销系统.b5130798.jpg";